// Some packs sell a perk a player can hold only once — the growth funds. The backend
// records the perk with a plain insert keyed on the player, so re-buying such a pack
// makes payment validation fail forever (duplicate `growth_funds.PRIMARY`) while the
// player has already been charged. The client must therefore never offer one of these
// packs to a player who already owns the perk.
//
// Maps each one-time perk to the /api/store/player-state flag that says the player has it.
export const ONE_TIME_PERK_FLAGS = Object.freeze({
    growthFund: 'playerGrowthFund',
    monsterGrowthFund: 'playerMonsterGrowthFund',
});

// The one-time perk carried by `pack` that `playerState` says is already owned, or null.
export function ownedOneTimePerk(pack, playerState = {}) {
    for (const perk of pack?.perks ?? []) {
        const flag = ONE_TIME_PERK_FLAGS[perk];
        if (flag && playerState[flag]) return perk;
    }
    return null;
}

// Whether `pack` may be offered for purchase. Ordinary packs always may. A pack carrying
// a one-time perk may only once player state has actually loaded (the fetch is non-fatal,
// and an unloaded state leaves every flag at its default `false`) and says it is not owned.
export function canOfferPack(pack, playerState = {}, playerStateLoaded = false) {
    const gated = (pack?.perks ?? []).some((perk) => perk in ONE_TIME_PERK_FLAGS);
    if (!gated) return true;
    return playerStateLoaded && ownedOneTimePerk(pack, playerState) === null;
}
